<div class="position-relative support-menu-container">
    <button type="button" class="bs-btn gap-2 border-rounded btn-in-header">
        <span>Support</span>
		<i class="far fa-question"></i>
    </button>
    <div class="drop-menu">
        <ul>
            <li class="flex-row gap-2 align-items-center"
				(click)="goToKnowledgeBase(dic.CONSTANTS.supportPages.whatsNew)">
                <i class="far fa-bullhorn"></i>
                <span>What's New</span>
            </li>
            <hr/>
			<li class="flex-row gap-2 align-items-center expandable">
				<i class="far fa-book"></i>
				<span>Knowledge Center</span>
				<div class="drop-menu sub-menu">
					<ul>
						<li class="flex-row gap-2 align-items-center"
							(click)="goToKnowledgeBase(dic.CONSTANTS.supportPages.faq);">
							<i class="far fa-comments"></i>
							<span>FAQ</span>
						</li>
						<li class="flex-row gap-2 align-items-center expandable">
							<i class="far fa-network-wired"></i>
							<span>Technical Documentation</span>
							<div class="drop-menu sub-menu">
								<ul>
									<li>
										<a class="flex-row gap-2 align-items-center"
										   href="https://docs.trustifi.com/docs/general"
										   target="_blank" rel="noopener noreferrer nofollow">
											<span>General</span>
											<i class="far fa-external-link-alt"></i>
										</a>
									</li>
									<li>
										<a class="flex-row gap-2 align-items-center"
										   href="https://docs.trustifi.com/docs/inbound-shield"
										   target="_blank" rel="noopener noreferrer nofollow">
											<span>Inbound Shield</span>
											<i class="far fa-external-link-alt"></i>
										</a>
									</li>
									<li>
										<a class="flex-row gap-2 align-items-center"
										   href="https://docs.trustifi.com/docs/outbound-shield"
										   target="_blank" rel="noopener noreferrer nofollow">
											<span>Outbound Shield</span>
											<i class="far fa-external-link-alt"></i>
										</a>
									</li>
									<li>
										<a class="flex-row gap-2 align-items-center"
										   href="https://docs.trustifi.com/docs/dlp-rules-policies-guide"
										   target="_blank" rel="noopener noreferrer nofollow">
											<span>Data Loss Prevention</span>
											<i class="far fa-external-link-alt"></i>
										</a>
									</li>
									<li>
										<a class="flex-row gap-2 align-items-center"
										   href="https://docs.trustifi.com/docs/account-takeover-protection"
										   target="_blank" rel="noopener noreferrer nofollow">
											<span>Account Takeover Protection</span>
											<i class="far fa-external-link-alt"></i>
										</a>
									</li>
									<li>
										<a class="flex-row gap-2 align-items-center"
										   href="https://docs.trustifi.com/docs/archive-1"
										   target="_blank" rel="noopener noreferrer nofollow">
											<span>Archive</span>
											<i class="far fa-external-link-alt"></i>
										</a>
									</li>
									<li>
										<a class="flex-row gap-2 align-items-center"
										   href="https://docs.trustifi.com/docs/email-add-ins"
										   target="_blank" rel="noopener noreferrer nofollow">
											<span>Email Add-ins</span>
											<i class="far fa-external-link-alt"></i>
										</a>
									</li>
									<li>
										<a class="flex-row gap-2 align-items-center"
										   href="https://docs.trustifi.com/docs/threat-simulation"
										   target="_blank" rel="noopener noreferrer nofollow">
											<span>Threat Simulation</span>
											<i class="far fa-external-link-alt"></i>
										</a>
									</li>
									<li>
										<a class="flex-row gap-2 align-items-center"
										   href="https://docs.trustifi.com/docs/dmarc-analyzer-1"
										   target="_blank" rel="noopener noreferrer nofollow">
											<span>DMARC Analyzer</span>
											<i class="far fa-external-link-alt"></i>
										</a>
									</li>
									<li>
										<a class="flex-row gap-2 align-items-center"
										   href="https://docs.trustifi.com/docs/single-sign-on-integrations"
										   target="_blank" rel="noopener noreferrer nofollow">
											<span>Single Sign-On Integration</span>
											<i class="far fa-external-link-alt"></i>
										</a>
									</li>
								</ul>
							</div>
						</li>
						<li>
							<a class="d-inline-flex align-items-center gap-2"
							   href="https://docs.trustifi.com/docs/technical-constraints"
							   target="_blank" rel="noopener noreferrer nofollow">
								<i class="far fa-compress-alt"></i>
								<span>Technical Constraints</span>
							</a>
						</li>
						<li class="flex-row gap-2 align-items-center"
							(click)="goToKnowledgeBase(dic.CONSTANTS.supportPages.knowledgeBase, 'Sensitivity_Engine')">
							<i class="fas fa-shield-alt"></i>
							<span>Sensitivity Engine</span>
						</li>
						<li class="flex-row gap-2 align-items-center"
							(click)="goToKnowledgeBase(dic.CONSTANTS.supportPages.trainingVideos)">
							<i class="far fa-film"></i>
							<span>Training Videos</span>
						</li>
					</ul>
				</div>
			</li>
            <hr/>
            <li class="flex-row gap-2 align-items-center expandable">
                <i class="far fa-gavel"></i>
                <span>Compliance and Regulation</span>
                <div class="drop-menu sub-menu">
                    <ul>
                        <li>
                            <a class="flex-row gap-2 align-items-center"
                               href="{{gs.hipaa}}"
                               target="_blank" rel="noopener noreferrer nofollow">
                                <span>HIPAA</span>
                                <i class="far fa-external-link-alt"></i>
                            </a>
                        </li>
                        <li>
                            <a class="flex-row gap-2 align-items-center"
                               href="{{gs.gdpr}}"
                               target="_blank" rel="noopener noreferrer nofollow">
                                <span>GDPR</span>
                                <i class="far fa-external-link-alt"></i>
                            </a>
                        </li>
                        <li>
                            <a class="flex-row gap-2 align-items-center"
                               href="https://trustifi.com/iso27001.pdf"
                               target="_blank" rel="noopener noreferrer nofollow">
                                <span>ISO 27001</span>
                                <i class="far fa-external-link-alt"></i>
                            </a>
                        </li>
                    </ul>
                </div>
            </li>
            <hr/>
            <li>
                <a class="flex-row gap-2 align-items-center"
                   href="{{gs.sla}}"
                   target="_blank" rel="noopener noreferrer nofollow">
                    <i class="far fa-handshake"></i>
                    <span>SLA</span>
                    <i class="far fa-external-link-alt"></i>
                </a>
            </li>
            <li *ngIf="isEmdrSla">
                <a class="flex-row gap-2 align-items-center"
                   href="{{gs.emdrSla}}"
                   target="_blank" rel="noopener noreferrer nofollow">
                    <i class="far fa-handshake"></i>
                    <span>EMDR SLA</span>
                    <i class="far fa-external-link-alt"></i>
                </a>
            </li>
            <hr/>
            <li>
                <a class="flex-row gap-2 align-items-center"
                   href="https://status.trustifi.com/"
                   target="_blank" rel="noopener noreferrer nofollow">
                    <i class="far fa-signal"></i>
                    <span>Status Page</span>
                    <i class="far fa-external-link-alt"></i>
                </a>
            </li>
            <hr/>
            <li class="flex-row gap-2 align-items-center"
				*ngIf="gs.userInfo?.plan.allow_support_wa"
                (click)="goToTicketsPage()">
                <i class="far fa-headset"></i>
                <span>Contact Support</span>
            </li>
        </ul>
    </div>
</div>

